export const validateNumericInput = (value) => {
    if (value && !/^\d*\.?\d*$/.test(value)) {
      return 'Please enter a valid number (commas are not allowed)';
    }
    return undefined;
};